
































































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import MemberKey from "@/components/member-key";
import _ from "lodash";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);

    const member = computed(() => memberStore.member);

    // 氏名の間に全角スペースを入れる
    const setFullWidthMemberName = (name1: string, name2: string) => {
      return name1 + "　" + name2;
    };
    // 氏名の間に半角スペースを入れる
    const setHalfWidthMemberName = (name1: string, name2: string) => {
      return name1 + " " + name2;
    };
    const memberName = setFullWidthMemberName(member.value.name_1, member.value.name_2);
    const memberNameKana = setHalfWidthMemberName(member.value.kana_name_1, member.value.kana_name_2);

    onMounted(() => {
      memberStore.clearMemberPersonalEditParams();
      memberStore.setAuthorizationHeader(accessToken.value);
      memberStore.getMember();
    });

    return {
      member,
      memberName,
      memberNameKana
    };
  },
  components: {}
});
